"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "7",
  cy: "14",
  r: "3"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "11",
  cy: "6",
  r: "3"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "16.6",
  cy: "17.6",
  r: "3"
}, "2")], 'ScatterPlotRounded');